import styles from './highlight-card.module.scss';

const HighlightCard = ({ imgLink, brand, onClick }) => {
    return (
        <div className={styles.container} onClick={onClick}>
            <img src={imgLink} alt={brand} />
            <h3>{brand}</h3>
        </div>
    );
};

export default HighlightCard;
